import React from 'react';
import AdSense from 'react-adsense';

export const GoogleAdResponsiveUnitMobile = () => (
  <>
    {typeof window !== 'undefined' && window.innerWidth <= 768 ? (
      <AdSense.Google
        key={Math.random()}
        client="ca-pub-8740909081146912"
        slot="8880978095"
        style={{ display: 'block' }}
        format="auto"
        responsive="true"
      />
    ) : null}
  </>
);

export const GoogleAdResponsiveUnitDesktop = () => (
  <>
    {typeof window !== 'undefined' && window.innerWidth >= 768 ? (
      <AdSense.Google
        key={Math.random()}
        client="ca-pub-8740909081146912"
        slot="8880978095"
        style={{ display: 'block' }}
        format="auto"
        responsive="true"
      />
    ) : null}
  </>
);

export const GoogleAdFluid = () => (
  <AdSense.Google
    key={Math.random()}
    client="ca-pub-8740909081146912"
    slot="8880978095"
    style={{ display: 'block' }}
    layout="in-article"
    format="fluid"
  />
);

/* <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
<!-- 7azzak -->
<ins class="adsbygoogle"
     style="display:block"
     data-ad-client="ca-pub-8740909081146912"
     data-ad-slot="8880978095"
     data-ad-format="auto"
     data-full-width-responsive="true"></ins>
<script>
     (adsbygoogle = window.adsbygoogle || []).push({});
</script> */

// Check Guide https://malloc.fi/google-adsense-with-gatsby-js

// other option is to return as is but escape everything , check https://github.com/gatsbyjs/gatsby/issues/11160
